module.exports = __webpack_public_path__ + "static/media/cosmetics-blog.74db3a7d.md";